import { StorageService, actions } from "../routes/services/storage.service";
import { PermissionsService } from "../routes/services/permissions.service";
import { ClientsService } from "../routes/services/clients.service";
import { SocketService } from "../routes/services/socket.service";
import { UsersService } from "../routes/services/users.service";
import { PondService } from "../routes/services/pond.service";
import { MenuService } from "../core/menu/menu.service";
import { Menu } from "../routes/menu";
import { Injectable } from "@angular/core";
import { FarmService } from "../routes/services/farm.service";
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from "@angular/router";
import { GlobalFunction, urlClient, urlAdmin } from "../routes/services/globalFuntion";
import { submitCycle } from "../routes/Clients/cycles-plantings/interfaces/cycle.interface";
import { CyclesService } from "../routes/Clients/cycles-plantings/services/cycles.service";
import moment from "moment";

@Injectable({
  providedIn: "root"
})
export class PreferenceGuard implements CanActivate {
  constructor(
    public permissionsService: PermissionsService,
    public storageService: StorageService,
    public globalFunction: GlobalFunction,
    public clientService: ClientsService,
    public socketService: SocketService,
    public userService: UsersService,
    public menuService: MenuService,
    public pondService: PondService,
    public router: Router,
    public farmService: FarmService,
    public cyclesService: CyclesService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.getPetition(route, state);
  }
  cycles: submitCycle[] = [];
  // Estado del ciclo pedido por adelantado en la carga inicial
  private prefetchedCycleStatus: Promise<{
    cycles: submitCycle[];
    status: 1 | 2 | 3 | 4 | 5;
  }> | null = null;

  /**
   * Pide el estado del ciclo actual de la granja si el usuario no es admin.
   * @param farm_id Granja a consultar.
   * @returns Promesa con ciclos y estado, o null si no aplica.
   */
  private requestCycleStatus(
    farm_id: any
  ): Promise<{ cycles: submitCycle[]; status: 1 | 2 | 3 | 4 | 5 }> | null {
    if (this.storageService.isAdmin() || !farm_id) return null;
    return this.cyclesService.getCurrentStatusCycles(Number(farm_id));
  }

  /**
   * Regenera el menu en base a la granja seleccionada y el estado actual del ciclo.
   * @returns Promise que finaliza cuando el menu fue recalculado.
   */
  public async refreshMenuByFarmCycle(): Promise<void> {
    let localUser: any = localStorage.getItem("USER");
    let user: any = localUser ? JSON.parse(localUser) : "";

    if (user) {
      const { mode, farm_id } = this.storageService.localValue;
      const my_permissions = this.permissionsService.all_permissions || null;
      const client_permissions = this.permissionsService.client_permissions || null;

      let status: 1 | 2 | 3 | 4 | 5 = 1;
      // Estado ya pedido por el guard para esta misma granja (se usa una sola vez)
      const prefetched = this.prefetchedCycleStatus;
      this.prefetchedCycleStatus = null;
      const statusTask = prefetched || this.requestCycleStatus(farm_id);
      if (statusTask) {
        const data = await statusTask;
        this.permissionsService.status_cycle = data.status;
        status = data.status;
        this.cycles = data.cycles;
      }
      console.log("El status es -->", status);

      const menu = Menu.menu({
        user,
        mode,
        client_permissions,
        my_permissions,
        farm_id: this.storageService.isSubclient() ? farm_id : null,
        status_cycle: status
      });

      this.menuService.push(menu);
    }
  }

  /**
   * Carga los permisos del usuario y, si es subcliente, los de su cliente (en paralelo).
   * @param user Usuario guardado en localStorage.
   * @returns Promesa que se resuelve al guardar los permisos en PermissionsService.
   */
  private async loadUserPermissions(user: any): Promise<void> {
    const [permissions, client_permissions] = await Promise.all([
      this.permissionsService.userPermissions().toPromise(),
      user && user.is_subclient
        ? this.permissionsService.getClientPermissionsWithSubclient().toPromise()
        : Promise.resolve(null)
    ]);
    if (permissions) {
      this.permissionsService.all_permissions = permissions;
    }
    if (client_permissions) {
      this.permissionsService.client_permissions = client_permissions;
    }
  }

  getPetition = async (route, state) => {
    const validateUrlMenu = () => {
      const menu = this.menuService.getMenu();
      let getQuery = this.storageService.getQueryFilters({
        current_url: ""
      });

      const { mode } = this.storageService.localValue;
      const validateUrl = () => {
        const is_admin = this.storageService.validateSoloAdmin();
        if ((is_admin && mode === 1) || !is_admin) {
          return urlClient;
        }
        return urlAdmin;
      };
      const similitud = (text1, text2) => {
        if (text1 && text2) {
          if (text1.startsWith(text2) || text2.startsWith(text1)) {
            return true;
          }
          if (text1.includes(text2) || text2.includes(text1)) {
            return true;
          }
        }
        return false;
      };
      const pathname = window.location.pathname;
      const exist = validateUrl().some((item) => pathname !== "/" && similitud(item, pathname));
      const status = this.permissionsService.status_cycle;
      if (status !== 1) {
        if (status === 5) {
          if (this.cycles[0].id) {
            this.router.navigateByUrl(`ciclos-siembras/continuar/${this.cycles[0].id}`);
          }
        } else {
          this.router.navigateByUrl(menu[0].link);
        }
      } else if (exist) {
        this.router.navigateByUrl(pathname);
      } else if (menu.length > 0) {
        const validate_current = getQuery.current_url !== "/" && getQuery.current_url !== "";
        if (this.storageService.localValue && validate_current) {
          const url = getQuery.current_url;
          const regex = /^\/granja\/(\d+)$/;
          const match = url && url.match(regex);

          if (match) {
            const id = match[1]; // Extrae el número capturado en el primer grupo
            this.pondService.getPonds("?fields=id&ordering=number", id).subscribe(
              (resp) => {
                this.router.navigateByUrl(url);
              },
              (err) => {
                this.router.navigateByUrl(menu[0].link);
              }
            );
          } else {
            const some = menu.some((item) => {
              if (item.submenu && item.submenu.length > 0) {
                return item.submenu.some((submenu) => similitud(submenu.link, url));
              }
              return similitud(item.link, url);
            });

            if (some) {
              this.router.navigateByUrl(url);
            } else {
              /* Agregar validacion de url de cliente y admin si coincide */
              const validateLink = () => {
                if (menu[0] && menu[0].link) {
                  return menu[0].link;
                }
                if (menu[0].submenu && menu[0].submenu.length > 0) {
                  return menu[0].submenu[0].link;
                }
              };
              this.router.navigateByUrl(validateLink());
            }
          }
        } else {
          this.router.navigateByUrl(menu[0].link);
        }
      }
    };
    const validateExistPermission = () => {
      let bool = this.permissionsService.validatePermissionsExistSubclient(route.data.permission);

      if (!bool) {
        validateUrlMenu();
      }

      return bool;
    };
    let bool = false;
    const validateBool = () => {
      if (route.data && route.data.is_admin) {
        bool = this.storageService.validateSoloAdmin();

        if (!bool) {
          validateUrlMenu();
        }
      } else if (
        route &&
        route.data &&
        route.data.permission &&
        !this.storageService.validateSoloAdmin()
      ) {
        /* Validamos si la ruta tiene un rol y existe en el objeto permisos */
        bool = validateExistPermission();
      } else {
        if (state.url === "/" || state.url === "") {
          validateUrlMenu();
        }
        bool = true;
      }
    };
    try {
      const loca_user: string | null = localStorage.getItem("USER") || null;
      /* Si hay token pero no usuario en localstorage la sesion esta incompleta: volver al login */
      /* (la landing "/" solo aplica sin token, ver Pages/landing_2026/landing.matcher.ts) */
      if (!loca_user) {
        bool = true;
        this.router.navigateByUrl("/login");
      } else {
        // Permisos, preferencias y usuario no dependen entre si: se piden en paralelo.
        // Las peticiones se crean antes de cualquier await para que usen los mismos
        // headers que antes (getPreferences cambia localValue al responder).
        const permissionsTask = !this.permissionsService.all_permissions
          ? this.loadUserPermissions(JSON.parse(loca_user))
          : Promise.resolve();
        const sessionTask = !this.storageService.view_modules
          ? Promise.all([
              this.storageService.getPreferences().toPromise(),
              this.userService.getUserInfo().toPromise()
            ])
          : null;
        const [, session] = await Promise.all([permissionsTask, sessionTask]);
        if (session) {
          const [data, user]: [any, any] = session;
          const client =
            data.personal_web.mode && data.personal_web.client && data.personal_web.client.user;

          /* Validacion para administradores en modo cliente */
          if (client) {
            try {
              const user = await this.userService
                .getUserInfo(data.personal_web.client.user.id, data.personal_web.client.token)
                .toPromise();
              if (!user) {
                this.storageService.localValue.client = null;
                this.storageService.localValue.mode = 0;
              }
            } catch (error) {
              this.storageService.localValue.client = null;
              this.storageService.localValue.mode = 0;
            }
          }
          // El estado del ciclo (menu) se pide con la granja guardada en paralelo a las granjas;
          // solo se repite si la granja guardada ya no es valida
          const savedFarmId = this.storageService.localValue.farm_id;
          const cyclesTask = this.requestCycleStatus(savedFarmId);
          if (this.storageService.localValue.client || user.client || user.is_subclient) {
            // Misma lista (id y nombre) que usa el header: la reutiliza en lugar de pedirla otra vez
            const query = this.farmService.sessionFarmsQuery(this.storageService.getClientID());
            const farms = await this.farmService.prefetchFarms(query).toPromise();
            if (farms.length === 0) {
              this.router.navigateByUrl("/hasNotFarm");
            } else if (!farms.some((farm) => farm.id === data.personal_web.farm_id)) {
              this.storageService.localValue.farm_id = farms[0].id;
            }
          }
          this.prefetchedCycleStatus =
            this.storageService.localValue.farm_id === savedFarmId ? cyclesTask : null;

          if (user) {
            localStorage.setItem("USER", JSON.stringify(user));
          }

          if (user.last_login) {
            /* TENEMOS QUE PONER LA FECHA y HORA DE LA ACTUALIZACION
          PARA FORZAR AL USUARIO QUE REESTABLEZCA LA CONTRASEÑA */

            let date_updated = new Date(`2024-02-01T16:51:14.038438-07:00`).getTime();
            let last_login = new Date(user.last_login).getTime();
            const cal = last_login < date_updated;

            if (cal && date_updated) {
              /* Vamos a reedirigir al cambio de contraseña */
              this.router.navigateByUrl("/lock");
              this.globalFunction.animation(
                "error",
                "¡Importante! Cambio de Contraseña",
                "Refuerza la Seguridad de tu Cuenta"
              );
            } else {
              if (data && data.personal_web && user) {
                let localValue = data.personal_web;
                const insert_menu = async () => {
                  this.storageService.localValue = localValue;
                  await this.refreshMenuByFarmCycle();
                  this.storageService.view_modules = true;
                  await validateBool();
                };
                if (user.permissions && user.user_type === 0 && user.permissions.alerts_only) {
                  localValue.current_url = "/alerts";
                  localValue.client = null;
                  localValue.mode = 0;
                  insert_menu();
                } else {
                  /* Validamos las url */
                  await insert_menu();
                  await validateUrlMenu();
                }

                let actions: Array<actions> = [];
                if (
                  (localValue.farm_id && !this.storageService.validateSoloAdmin()) ||
                  localValue.mode === 1
                ) {
                  actions = [
                    {
                      type: "gateways.add_listener",
                      data: { farm: Number(localValue.farm_id) }
                    }
                  ];
                } else {
                  actions = [{ type: "ping" }];
                }
                await this.socketService.connectSocket(actions);
              }
            }
          }
        } else {
          validateBool();
        }
      }
    } catch (error) {
      bool = false;
      this.storageService.view_modules = false;
    }
    if (!bool) {
      this.globalFunction.animation(
        "error",
        "ERROR",
        "Usted no tiene permisos para ingresar a esta pantalla"
      );
    }

    return bool;
  };
}
